function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.46875 0C5.67595 0 5.87466 0.0856024 6.02118 0.237976C6.16769 0.390349 6.25 0.597012 6.25 0.8125V1.625H18.75V0.8125C18.75 0.597012 18.8323 0.390349 18.9788 0.237976C19.1253 0.0856024 19.324 0 19.5312 0C19.7385 0 19.9372 0.0856024 20.0837 0.237976C20.2302 0.390349 20.3125 0.597012 20.3125 0.8125V1.625H21.875C22.7038 1.625 23.4987 1.96741 24.0847 2.5769C24.6708 3.1864 25 4.01305 25 4.875V15.1319C24.5131 15.0452 24.0118 15 23.5 15C23.4791 15 23.4583 15.0001 23.4375 15.0002V6.5H1.5625V22.75C1.5625 23.181 1.72712 23.5943 2.02015 23.899C2.31317 24.2038 2.7106 24.375 3.125 24.375H15.0445C15.1017 24.9345 15.2132 25.478 15.3736 26H3.125C2.2962 26 1.50134 25.6576 0.915291 25.0481C0.32924 24.4386 0 23.612 0 22.75V4.875C0 4.01305 0.32924 3.1864 0.915291 2.5769C1.50134 1.96741 2.2962 1.625 3.125 1.625H4.6875V0.8125C4.6875 0.597012 4.76981 0.390349 4.91632 0.237976C5.06284 0.0856024 5.26155 0 5.46875 0Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5 11H8V14H5V11ZM5 17H8V20H5V17ZM11 11H14V14H11V11ZM11 17H14V20H11V17ZM17 11H20V14H17V11ZM17 17H20L18.5 18.5L17 20V17Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M32 24C32 28.4183 28.4183 32 24 32C19.5817 32 16 28.4183 16 24C16 19.5817 19.5817 16 24 16C28.4183 16 32 19.5817 32 24Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M24 19C24.2652 19 24.5196 19.1054 24.7071 19.2929C24.8946 19.4804 25 19.7348 25 20V23H28C28.2652 23 28.5196 23.1054 28.7071 23.2929C28.8946 23.4804 29 23.7348 29 24C29 24.2652 28.8946 24.5196 28.7071 24.7071C28.5196 24.8946 28.2652 25 28 25H25V28C25 28.2652 24.8946 28.5196 24.7071 28.7071C24.5196 28.8946 24.2652 29 24 29C23.7348 29 23.4804 28.8946 23.2929 28.7071C23.1054 28.5196 23 28.2652 23 28V25H20C19.7348 25 19.4804 24.8946 19.2929 24.7071C19.1054 24.5196 19 24.2652 19 24C19 23.7348 19.1054 23.4804 19.2929 23.2929C19.4804 23.1054 19.7348 23 20 23H23V20C23 19.7348 23.1054 19.4804 23.2929 19.2929C23.4804 19.1054 23.7348 19 24 19Z",
  fill: "#0600AD",
  fillOpacity: 0.7
});

function SvgRemoveCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveCalendarIcon);
export default __webpack_public_path__ + "static/media/remove-calendar-icon.c423830b.svg";
export { ForwardRef as ReactComponent };